import type { ReactNode } from 'react';

import { STUDIO_PANELS } from './wizardPanels';

interface ReelsStudioShellProps {
  header: ReactNode;
  column: ReactNode;
  /** Sits on the page background, not on a card, as the old Studio's player did. */
  main: ReactNode;
  aside: ReactNode;
}

/** The Studio is not a numbered step: a header card over its three columns, with no wizard column. */
export const ReelsStudioShell = ({ header, column, main, aside }: ReelsStudioShellProps) => (
  <div className={STUDIO_PANELS.body}>
    <header data-panel="header" className={STUDIO_PANELS.header}>
      {header}
    </header>
    <div className={STUDIO_PANELS.row}>
      <aside data-panel="column" className={STUDIO_PANELS.column}>
        {column}
      </aside>
      <section data-panel="main" className={STUDIO_PANELS.main}>
        {main}
      </section>
      <aside data-panel="aside" className={STUDIO_PANELS.aside}>
        {aside}
      </aside>
    </div>
  </div>
);
